import { supabase } from '../infrastructure/supabase/SupabaseConfig';

/**
 * Kiểm tra sức khỏe hệ thống và các tham số còn thiếu
 */
export async function checkSystemHealth(userId) {
    const gaps = [];

    try {
        // 1. Kiểm tra Chi nhánh (Locations)
        const { count: locationCount, error: locError } = await supabase
            .from('locations')
            .select('*', { count: 'exact', head: true })
            .eq('owner_id', userId);

        if (locError) {
            console.warn('[ConfigAudit] locError:', locError);
        } else if (locationCount === 0) {
            gaps.push({
                id: 'MISSING_LOCATION',
                title: 'Chưa có Chi nhánh',
                message: 'Bạn cần tạo ít nhất một chi nhánh để bắt đầu quản lý.',
                action: 'Thiết lập Chi nhánh',
                link: '/settings/locations'
            });
        }

        // 2. Kiểm tra Phân quyền Nhân sự (Staff Assignments)
        if (userId) {
            const { data: assignment, error: assignError } = await supabase
                .from('staff_assignments')
                .select('*')
                .eq('user_id', userId)
                .maybeSingle();

            if (assignError) {
                console.warn('[ConfigAudit] assignError:', assignError);
            } else if (!assignment) {
                gaps.push({
                    id: 'MISSING_ASSIGNMENT',
                    title: 'Chưa gán địa điểm',
                    message: 'Tài khoản của bạn chưa được gán vào bất kỳ chi nhánh nào.',
                    action: 'Phân quyền ngay',
                    link: '/hrm/assignments'
                });
            }
        }

        // 3. Kiểm tra Danh mục Sản phẩm (Inventory)
        const { count: productCount, error: prodError } = await supabase
            .from('products')
            .select('*', { count: 'exact', head: true })
            .eq('owner_id', userId);

        if (prodError) {
            console.warn('[ConfigAudit] prodError:', prodError);
        } else if (productCount === 0) {
            gaps.push({
                id: 'MISSING_PRODUCTS',
                title: 'Danh mục món trống',
                message: 'Hãy nhập danh sách món ăn từ POS để hệ thống có thể đối soát.',
                action: 'Nhập danh mục',
                link: '/inventory/products'
            });
        }

        return gaps;
    } catch (err) {
        console.error('[ConfigAudit] Health check failed:', err);
        return [];
    }
}
